var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 11.402 16.402"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.201 0c1.44 0 2.66.506 3.678 1.523 1.017 1.018 1.523 2.239 1.523 3.678s-.506 2.66-1.523 3.678C8.86 9.896 7.64 10.402 6.2 10.402H2.402v6H0V0zM2.402 2.402V8h3.922c.768 0 1.431-.276 1.977-.821.545-.546.822-1.21.822-1.978 0-.767-.276-1.432-.821-1.977a2.7 2.7 0 0 0-1.978-.822z"
  })));
};
export default SvgParking;